import React, { useState, useEffect, useRef } from "react";
import LoaderIndex from "~/containers/LoaderIndex";


const AgregatorSocSietiPrihlaseniePage = (props) => {
   


  return (
        <div className="container static-page ass">  
            
                    {props.connect === 'success' ? (
                        <div className="ass-msg">Prepojenie vášho IG konta s TASR agregátorom je aktívne.</div>
                    ) : props.connect === 'error' ? (
                        <div className="ass-msg error">Nastala chyba. Prepojenie vášho IG konta s TASR agregátorom nie je aktívne.</div>
                    ) : (
                        <a href="/agregator-soc-sieti/prihlasenie" className="btn btn-primary">Spárovať Instagram s TASR</a>
                    )}
        </div>        
  );
};

export default AgregatorSocSietiPrihlaseniePage;